import React, { Fragment } from 'react';
import classNames from 'classnames';
import InlineSVG from 'components/general/InlineSVG/InlineSVG';

const PDF: React.SFC & { Section?: React.SFC } & { CoverPage?: React.SFC } & {
BackPage?: React.SFC;
} = ({ children }) => <div className="pdf">{children}</div>;

const PDFCoverPage: React.SFC<CoverPageProps> = ({ title, date }) => (
  <header className="pdf__cover-page">
    <img
      className="pdf-frame__logo"
      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjMzcHgiIGhlaWdodD0iNzVweCIgdmlld0JveD0iMCAwIDIzMyA3NSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDMuMiAoMzkwNjkpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmxvZ288L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0ibG9nbyIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTIzMi42MDQxODYsMCBMMjEwLjY4MzQxNSwwIEwxOTUuNDcxMDg2LDI2LjExNjIxNjIgTDE4MC4yNzkxNTksMCBMMTU3Ljk1MDMzMywwIEwxNTguMDI3ODYzLDc0LjU3NDMyNDMgTDE1Ny45NTg0OTQsNzQuNjYzNTEzNSBMMTc0LjU3ODYxNiw3NC42NjM1MTM1IEwxNzQuNTc4NjE2LDI0LjQ2NjIxNjIgTDE5NS41NjA4NTgsNTcuNDk0NTk0NiBMMjE1LjkxMDYxMywyNC42MTIxNjIyIEwyMTUuOTEwNjEzLDc0LjQ3NzAyNyBMMjMyLjYwNDE4Niw3NC40NzcwMjcgTDIzMi42MDQxODYsMCBaIE04NC43ODk5NjUsMzEuMDcwMjcwMyBMODQuNzg5OTY1LDAuMTU4MTA4MTA4IEwxMTUuMjcxNzUxLDAuMTU4MTA4MTA4IEMxMjguNDkyNzY3LDAuMTU4MTA4MTA4IDE0Mi42Njg2MzQsNi44NDMyNDMyNCAxNDIuNjY4NjM0LDIyLjU3NzAyNyBDMTQyLjY2ODYzNCwzMS41NDg2NDg2IDEzOC4xNTU1MzQsMzguNTQ1OTQ1OSAxMjkuNzc0MDYzLDQyLjQ5NDU5NDYgTDE1Ny4xMTM4MTgsNzQuNjY3NTY3NiBMMTM1LjU1MjEzNyw3NC42Njc1Njc2IEwxMTEuNDExNTQxLDQ1LjYyNDMyNDMgTDEwMS4yMzQ2MjMsNDUuNjI0MzI0MyBMMTAxLjIzNDYyMyw3NC4zMzUxMzUxIEw4NC43MjA1OTU0LDU4LjQ0NzI5NzMgTDg0LjcyMDU5NTQsNDcuNTkwNTQwNSBMMTAxLjQyNjQxLDMxLjA3MDI3MDMgTDg1LjI3NTU1MTcsMzEuMDcwMjcwMyBMODQuNzg5OTY1LDMxLjA3MDI3MDMgWiBNMTEyLjkwOTEwNywzMS4wNzAyNzAzIEMxMTguNjIxODkxLDMxLjA3MDI3MDMgMTI1LjQxMTk0NCwyOS42NTU0MDU0IDEyNS40OTc2MzYsMjIuODg5MTg5MiBDMTI1LjQ5NzYzNiwxNy42OTU5NDU5IDEyMS4zODAzNSwxNC4zMTQ4NjQ5IDExNC45NjU3MDksMTQuMzE0ODY0OSBMMTA4Ljk2MzIwNSwxNC4yMzc4Mzc4IEwxMDEuMzQ4ODc5LDE0LjIzNzgzNzggTDEwMS4zNDg4NzksMzEuMDcwMjcwMyBMMTEyLjkwOTEwNywzMS4wNzAyNzAzIEwxMTIuOTA5MTA3LDMxLjA3MDI3MDMgWiBNMjkuMjE2ODEyNiwyOC40NzU2NzU3IEMyMi4wMTA1NDI5LDI1Ljk1ODEwODEgMTcuNTU4NjUxNSwyNC4xNSAxNy41NTg2NTE1LDIwLjQ1MjcwMjcgQzE3LjU1ODY1MTUsMTUuODkxODkxOSAyMS44NTU0ODE2LDE0LjMxODkxODkgMjUuODkxMTU1OSwxNC4zMTg5MTg5IEMyOS41MDk2OTkyLDE0LjQzMTAyMjkgMzMuMDIyOTg1OSwxNS41NTUxNjYzIDM2LjAyNzI2OCwxNy41NjIxNjIyIEw0NS4yMTI2MDk1LDUuODQxODkxODkgQzM5LjIyOTg1OTIsMi4wNTc3OTg1OSAzMi4yNjg5NDE5LDAuMDgzMDkxMzUxMSAyNS4xNzcwNTc4LDAuMTU4MTA4MTA4IEMxMy4zODAxNTc2LDAuMTU4MTA4MTA4IDEuNTA5ODA3MzYsNi42MDgxMDgxMSAxLjUwOTgwNzM2LDIxLjE2MjE2MjIgQzEuNTA5ODA3MzYsMzQuODQ4NjQ4NiAxMi45MTA4OTMyLDM5LjE3ODM3ODQgMjIuMDk2MjM0Nyw0Mi42NDg2NDg2IEMyOS45MzA5MTA3LDQ1LjYyNDMyNDMgMzQuNjk3MDA1Myw0Ny42NzE2MjE2IDM0LjY5NzAwNTMsNTIuMzkwNTQwNSBDMzQuNjk3MDA1Myw1OC40NDcyOTczIDI5LjE1NTYwNDIsNjAuNTcxNjIxNiAyNC40MDU4MzE5LDYwLjU3MTYyMTYgQzE4LjE1MDMzMjcsNjAuNTcxNjIxNiAxNC4zNTEzMzEsNTguNDQ3Mjk3MyA5LjQ0MjQxNjgxLDUzLjk2MzUxMzUgTDAuMDEyMjQxNjgxMyw2Ni4wMDgxMDgxIEM3LjEzNjkwMDE4LDcyLjE0NTk0NTkgMTQuODE2NTE0OSw3NC44OTg2NDg2IDI0LjMyMDE0MDEsNzQuODk4NjQ4NiBDMzcuMzc3OTMzNSw3NC44OTg2NDg2IDUxLjQ3NjI2OTcsNjcuNjYyMTYyMiA1MS40NzYyNjk3LDUxLjc5MDU0MDUgQzUxLjQ3NjI2OTcsMzYuMjkxODkxOSAzOS4xMjQ0MTMzLDMxLjk2NjIxNjIgMjkuMjI5MDU0MywyOC41MDgxMDgxIEwyOS4yMTY4MTI2LDI4LjQ3NTY3NTcgWiIgaWQ9IlNoYXBlIiBmaWxsPSIjMDAwMDAwIj48L3BhdGg+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iU2hhcGUiIGZpbGw9IiNGQjYwMjAiIHBvaW50cz0iODQuNzk4MTI2MSAzMi41MDU0MDU0IDUwLjY3MjM5OTMgMzIuNTA1NDA1NCA2MS4zNTkzODcgNDUuNTE0ODY0OSA4NS4yNzE0NzExIDMyLjY5MTg5MTkiPjwvcG9seWxpbmU+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="
    />

    <Fragment>
      <div className="pdf__cover-title-block">
        <div className="pdf__cover-content-holder">
          <h1 className="pdf__cover-title">{title}</h1>
        </div>
        <div className="pdf__cover-content-holder">
          <span className="pdf__cover-subtitle">Global Security Insight</span>
        </div>
        <div className="pdf__cover-content-holder">
          <span className="pdf__cover-date">{date}</span>
        </div>
      </div>
    </Fragment>

    <div className="pdf__cover-note">
      <p>
        The information provided to you in this document is confidential and prepared for your
        sole use. It must not be copied (in whole or in part) or used for any purpose other than
        to evaluate its contents and must not be shared with any third party. Our terms of
        business contain further information with regards to use of our reports.
      </p>
    </div>
  </header>
);

interface CoverPageProps {
  title: string;
  date: string;
}

PDF.CoverPage = PDFCoverPage;

const PDFSection: React.SFC<SectionPropDef> = ({children, types}) => (
  <section className={classNames('pdf__section', types.map(type => `pdf__section--${type}`))}>
    {children}
  </section>
);

PDFSection.defaultProps = {
  types: [],
};

interface SectionPropDef {
  types: string[];
}

PDF.Section = PDFSection;

const PDFBackPage: React.SFC = () => (
  <footer className="pdf__back">
    <img className="pdf__back-img" src="/static/img/report-back-page.png"/>
  </footer>
);

PDF.BackPage = PDFBackPage;

export default PDF;
